import React from 'react';
import MoonLoader from 'react-spinners/MoonLoader';
import base from './base.jsx';
import misc from './misc.jsx';

class Button extends base.BaseComponent {
  getAlertType() {
    return "success";
  }

  getDefaultState() {
    return {
      loading: this.props.loading || false,
      api: this.props.api
    }
  }

  getButtonClass() {
    return this.props.buttonClass || "btn-primary"
  }

  onClick() {
    if (this.props.onClick) {
      const result = this.props.onClick();
      if (result && result.then) {
        // This is a Promise
        result
          .then(this.onSuccess.bind(this))
          .catch(this.onError.bind(this));
      } else {
        this.setState({
          loading: false
        });
      }
    } else {
      console.warn('Button has no onClick');
      this.setState({
        loading: false
      });
    }

  }

  onError(errorMessage) {
    if (this.props.onError) {
      this.props.onError(errorMessage);
    } else {
      Utils.alert(errorMessage);
    }
    this.setState({
      loading: false
    });
  }

  onSuccess(result) {
    if (this.props.onSuccess) {
      this.props.onSuccess(result);
    } else if (result.message) {
      Utils.alert(result.message, this.getAlertType());
    }
    this.setState({
      loading: false
    });
  }

  render() {
    var hiddenStyle = {}
    var disabled = this.props.disabled;

    if (this.state.loading) {
      hiddenStyle.opacity = "0"
      disabled = true;
    }

    return <button
      type={this.props.type || "submit"}
      className={this.props.className || ("btn ladda-button btn-sm-on-xs " + this.getButtonClass())}
      data-spinner-size="16"
      data-style="ball-clip-rotate"
      onClick={this.onClick.bind(this)}
      disabled={disabled}
    >
      <misc.If test={this.state.loading}>
        <div className="loading-container-div">
          <div className="spinner-div">
            <MoonLoader size={25}/>
          </div>
        </div>
      </misc.If>
      <div style={hiddenStyle}>
        <misc.If test={ this.props.icon }>
          <i className={ this.props.icon }></i>
        </misc.If>
        <misc.If test={ this.props.label }>
          <span className="ladda-label">{ this.props.label }</span>
        </misc.If>
      </div>
    </button>
  }
}

class ApiButton extends Button {
  onClick() {
    this.setState({
      loading: true
    });

    $.ajax({
      url: this.state.api,
      method: this.props.method || "POST"
    }).done((data, textStatus) => {
      if (data.status <= 300) {
        this.onSuccess(data);
      } else {
        this.onError(data.message || "Internal server error");
      }
    }).fail((jqXHR, textStatus, errorThrown) => {
      var errorMessage = Utils.errorMessage(textStatus, errorThrown);
      this.onError(errorMessage);
    });
  }

}

class ApiToggleButton extends ApiButton {
  getDefaultState() {
    return {
      loading: this.props.loading || false,
      toggled: this.props.toggled || false,
      api: this.getAPI(this.props.toggled || false)
    }
  }

  getAPI(toggled) {
    if (toggled === undefined) {
      toggled = this.state.toggled;
    }

    return toggled ? this.props.toggleOffAPI : this.props.toggleOnAPI
  }

  getButtonLabel() {
    return this.state.toggled ? this.props.toggleOffLabel : this.props.toggleOnLabel;
  }

  getButtonClass() {
    return (this.state.toggled ? this.props.toggleOffClass : this.props.toggleOnClass) || "btn-primary";
  }

  getButtonIcon() {
    return this.state.toggled ? this.props.toggleOffIcon : this.props.toggleOnIcon;
  }

  getAlertType() {
    return "info";
  }

  onSuccess(result) {
    this.setState({
      toggled: !this.state.toggled,
      api: this.getAPI(!this.state.toggled)
    });
    super.onSuccess(result);
  }

  render() {
    var hiddenStyle = {}
    var disabled = this.props.disabled;

    if (this.state.loading) {
      hiddenStyle.opacity = "0"
      disabled = true;
    }

    return <button
        type={this.props.type || "submit"}
        className={"btn ladda-button btn-sm-on-xs " + this.getButtonClass()}
        data-spinner-size="32"
        data-style="zoom-out"
        onClick={ this.onClick.bind(this) }
        disabled={ disabled }
      >
      <misc.If test={ this.state.loading }>
        <div className="loading-container-div">
          <div className="spinner-div">
            <MoonLoader size={25}/>
          </div>
        </div>
      </misc.If>
      <div style={hiddenStyle}>
        <misc.If test={ this.getButtonIcon() }>
          <i className={ this.getButtonIcon() }></i>
        </misc.If>
        <misc.If test={ this.getButtonLabel() }>
          <span className="ladda-label">{ this.getButtonLabel() }</span>
        </misc.If>
      </div>
    </button>
  }
}


module.exports = {
  ApiButton: ApiButton,
  ApiToggleButton: ApiToggleButton,
  Button: Button
}
